import { Button } from "@components/button";
import { Input } from "@components/input";
import { Modal } from "@components/modal";
import { useForm } from "react-hook-form";
import styles from "./caches.module.scss";
import { useAdminCaches } from "@features/admin/caches";
import { useEffect } from "react";
import { useAdminUsers } from "@features/admin/users";
import { FlexLoader } from "@components/loader";
import { copyToClipboard } from "@helpers/utilities";
import { EllipsisText } from "@components/ellipsis-text";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  userId: string;
};

export const AdminCachesModal = ({ hideModal, isModalOpen, userId }: Props) => {
  const { state: userState } = useAdminUsers();
  const { state, getAdminCaches, createAdminCache } = useAdminCaches();

  useEffect(() => {
    getAdminCaches(userId);
  }, [getAdminCaches, userId]);

  const { control, getValues, reset } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const createCache = () => {
    const name = getValues().name;
    createAdminCache(userId, { name }).then(() => {
      getAdminCaches(userId);
    });
    reset();
  };

  // const changeApiKey = (cacheId: string) => {
  //   store.dispatch(setSetSelectedCache(cacheId));
  //   changeAdminCache(cacheId);
  // };
  const copyData = () => {
    let res = "";
    if (userState.apiKey == null) return;
    res += `Ваш API ключ: ${userState.apiKey}\n`;
    if (state.caches == null) return;
    state.caches.forEach((data, index) => {
      res += `Касса ${index + 1}: Название - ${data.name}, Id - ${data.id}\n`;
    });
    copyToClipboard(res);
  };

  return (
    <Modal isOpen={isModalOpen} onClose={hideModal} title={"Добавленные кассы"}>
      {state.loading ? (
        <FlexLoader />
      ) : (
        <>
          <div className={styles.listWrapper}>
            <ol>
              {state.caches?.map((cache, index) => (
                <li key={cache.id} className={styles.item}>
                  <div className={styles.itemName}>
                    {index + 1}.&nbsp;
                    <div style={{ display: "flex" }}>
                      <div>{cache.name}&nbsp;</div>
                      <div>
                        id -&nbsp;
                        <EllipsisText
                          inline
                          text={`${cache.id}`}
                          copy
                          startLength={10}
                        />
                      </div>
                    </div>
                    {/* <span
                      className={styles.reset}
                      onClick={() => {
                        changeApiKey(cache.id);
                      }}
                    >
                      &nbsp;- Сбросить ключ
                    </span> */}
                  </div>
                  {/* <div>API key: {cache.api_key}</div> */}
                </li>
              ))}
            </ol>
          </div>
          <div className={styles.input}>
            <Input control={control} name="name" label="Название кассы"></Input>
          </div>
          <Button buttonType="button" onClick={createCache}>
            Добавить кассу
          </Button>
          <Button
            onClick={copyData}
            style={{ marginTop: "10px" }}
            disabled={userState.apiKey == null || state.caches == null}
            buttonType="button"
          >
            Скопировать данные для подключения
          </Button>
        </>
      )}
    </Modal>
  );
};
